<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>メールアドレス・お知らせ通知設定の変更</HeadingOne>

    <WizardGroup class="_mb-md-60 _mb-sm-20">
      <MainWizard :active-index="2" type="useremail"></MainWizard>
    </WizardGroup>

    <p>
      以下の内容で変更しました。<br />
      その他のお客さま情報を変更する場合は、「お客さま情報を確認する」より変更する箇所をご選択のうえお手続きください。
    </p>

    <section>
      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <template v-if="!localUser(userData.id_type)">
              <!-- au IDに紐づくアドレスあり -->
              <template
                v-if="
                  showDefaultMail(
                    userData.ez_mail,
                    userData.mail_1,
                    userData.mail_2
                  )
                "
              >
                <TableRow>
                  <TableHeader rowspan="3"> メールアドレス※ </TableHeader>
                  <TableData>
                    {{ displayEzMail(userData.ez_mail) }}
                  </TableData>
                </TableRow>
                <TableRow>
                  <TableData>
                    {{ displayMail1(userData.mail_1) }}
                  </TableData>
                </TableRow>
                <TableRow>
                  <TableData>
                    {{ displayMail2(userData.mail_2) }}
                  </TableData>
                </TableRow>
              </template>
            </template>
            <!-- その他のアドレス -->
            <TableRow>
              <TableHeader>
                メールアドレス
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['loan_mail']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayLoanMail(userData.loan_mail) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                お知らせ通知設定
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="[
                    'cpn_ukt_flg',
                    'kri_tti_ukt_flg',
                    'hen_soku_ukt_flg',
                    'mns_stm_ukt_flg',
                  ]"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                <template v-if="userData.cpn_ukt_flg === '1'"
                  ><span
                    :class="{ red: isChangeNotice(diffKeys, 'cpn_ukt_flg') }"
                    >・キャンペーン情報</span
                  ><br
                /></template>
                <template v-if="userData.kri_tti_ukt_flg === '1'"
                  ><span
                    :class="{
                      red: isChangeNotice(diffKeys, 'kri_tti_ukt_flg'),
                    }"
                    >・お借り入れ時</span
                  ><br
                /></template>
                <template v-if="userData.hen_soku_ukt_flg === '1'"
                  ><span
                    :class="{
                      red: isChangeNotice(diffKeys, 'hen_soku_ukt_flg'),
                    }"
                    >・ご返済時</span
                  ><br
                /></template>
                <template v-if="userData.mns_stm_ukt_flg === '1'"
                  ><span
                    :class="{
                      red: isChangeNotice(diffKeys, 'mns_stm_ukt_flg'),
                    }"
                    >・マンスリーステートメント発行</span
                  ><br
                /></template>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>
      <div class="_mb-md-60 _mb-sm-30">
        <small
          >※au
          IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、<a
            href="https://id.auone.jp/"
            class="btn-text textlink"
            target="_blank"
            >au IDサイト</a
          >にて連絡先メールアドレスをご登録ください。</small
        >
      </div>

      <BtngroupSingle class="_mb-md-120 _mb-sm-40">
        <BtnMain class="-main" router-name="mb023">
          お客さま情報を確認する
        </BtnMain>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { isChangeNotice, diffKeysGet } from "@/utils/ChangeIcon";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import {
  localUser,
  showDefaultMail,
  displayEzMail,
  displayMail1,
  displayMail2,
  displayLoanMail,
} from "@/utils/UserData";

import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ChangeBadgeIcon from "@/components/badges/ChangeBadgeIcon";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Tem019",
  components: {
    ChangeBadgeIcon,
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    MainWizard,
    WizardGroup,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "メールアドレス・お知らせ通知設定の変更｜お客さま情報の確認・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報",
    });

    return {
      localUser,
      showDefaultMail,
      displayEzMail,
      displayMail1,
      displayMail2,
      displayLoanMail,
      isChangeNotice,
      diffKeysGet,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "メールアドレス・お知らせ通知設定の変更",
          active: true,
        },
      ],
      userData: {
        id_type: "",
        ez_mail: "",
        mail_1: "",
        mail_2: "",
        loan_mail: "",
        loan_mail_confirmation: "",
        cpn_ukt_flg: "",
        hen_soku_ukt_flg: "",
        kri_tti_ukt_flg: "",
        mns_stm_ukt_flg: "",
      },
      diffKeys: [],
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });

      diffKeysGet()
        .then((res) => {
          this.diffKeys = res;
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
</style>
